export default __webpack_public_path__ + "static/media/private bathroom.a7865c5c.svg";